import { MATCH_TYPES, MATCH_TYPES_FROM_AMAZON } from "../constants/campaign.constants"
import { matchTypesEnum } from "../types/customers"

export function getMatchTypesOptions() {
  return MATCH_TYPES.map((matchType) => {
    return {
      text: matchType,
      value: matchType,
    }
  })
}

export function getMatchTypesFromAmazonOptions() {
  return MATCH_TYPES_FROM_AMAZON.map((matchType) => {
    return {
      text: matchType,
      value: matchType,
    }
  })
}

export function getMatchTypeByCampaignName(campaignName: string) {
  if (campaignName.toLowerCase().includes(matchTypesEnum.RANKING.toLowerCase())) {
    return matchTypesEnum.RANKING
  }
  if (campaignName.toLowerCase().includes(matchTypesEnum.ASIN.toLowerCase())) {
    return matchTypesEnum.ASIN
  }
  if (campaignName.toLowerCase().includes(matchTypesEnum.BROAD.toLowerCase())) {
    return matchTypesEnum.BROAD
  }
  if (campaignName.toLowerCase().includes(matchTypesEnum.EXACT.toLowerCase())) {
    return matchTypesEnum.EXACT
  }
  if (campaignName.toLowerCase().includes(matchTypesEnum.PHRASE.toLowerCase())) {
    return matchTypesEnum.PHRASE
  }
  if (campaignName.toLowerCase().includes(matchTypesEnum.AUTO.toLowerCase())) {
    return matchTypesEnum.AUTO
  }

  return "not exists match type"
}
